import React from 'react';

import { Grid, AccordionDetails, AccordionSummary } from "@mui/material";
import { BannerGrid, SectionGrid, FAQGrid, FAQAccordion, FormGrid, StyledLink } from "./FAQ.js";

import { Footer } from '../../components/Footer/Footer.jsx';
import { Header } from '../../components/Header/Header.jsx';
import { Form } from '../../components/Form/Form.jsx';

import Circle from '../../assets/cangoo-banner-elemento.png'
import ArrowDown from "../../assets/cangoo-faq-icon-off.png"
import Cangoo from "../../assets/cangoo-faq-mascote.png"


export function FAQ() {
  const handleWhatsappClick = () => {
    window.open('https://wa.me/554833645744?text=', '_blank');
  };

    return (
      <>
      <Header/>
     
      <BannerGrid container>
        <Grid item xs={12} sm={12} md={12}>
<div className="title">
  <h1>Perguntas<br/>
  Frequentes</h1>
  <img src={Circle} alt="" />
</div>
        </Grid>
      </BannerGrid>

<SectionGrid container>
<Grid item xs={12} sm={12} md={12}>
<h1>Por que optar pelo<br/>
transporte aéreo?</h1>

<p>
Além de ser a forma mais segura para transporte de mercadorias, apresenta maior rapidez, bem
como controle sobre a localização da mercadoria, informações precisas sobre voos onde a carga se
encontra, horários de pouso, bem como até mesmo, assim que ela estiver em rota de entrega com
nossos motoristas, ou seja, é possível ter informações em tempo real, da coleta, à entrega da sua
carga! É você, a par de tudo que acontece, com a <span>Cangoo!</span>
</p>

<StyledLink to="/cotacao"><span className='button'>Simule agora mesmo seu envio</span></StyledLink>
</Grid>
</SectionGrid>


      <FAQGrid container>
 <div className='texto-inicial'>
 <h1>Ainda em dúvida?</h1>
 <p>
 Veja abaixo algumas perguntas e respostas com as principais dúvidas de nossos
 usuários e clientes.
 </p>
 </div>
 
     <FAQAccordion>
       <AccordionSummary expandIcon={<img src={ArrowDown} alt=''/>}>
         <h1>Como faço para solicitar uma coleta de mercadoria?</h1>
       </AccordionSummary>
       <AccordionDetails>
         <p>
         É simples, rápido, e possui duas formas:<br/><br/>
         Envie sua solicitação para: <a href="mailto:contato@vaidecangoo.com.br">contato@vaidecangoo.com.br</a> ou ainda, nos contate pelo nosso <span onClick={handleWhatsappClick}>WhatsApp!</span>
         </p>
       </AccordionDetails>
     </FAQAccordion>

     <FAQAccordion>
       <AccordionSummary expandIcon={<img src={ArrowDown} alt=''/>}>
         <h1>Como posso realizar uma cotação?</h1>
       </AccordionSummary>
       <AccordionDetails>
         <p>
         Preencha nosso formulário  <StyledLink to="/cotacao"><span>(Cotação de Frete)</span></StyledLink> e em seguida, lhe retornaremos.<br/>
         Você também pode fazer sua cotação através do nosso <span onClick={handleWhatsappClick}>WhatsApp!</span>
         </p>
       </AccordionDetails>
     </FAQAccordion>

     <FAQAccordion>
       <AccordionSummary expandIcon={<img src={ArrowDown} alt=''/>}>
         <h1>Como rastreio um envio?</h1>
       </AccordionSummary>
       <AccordionDetails>
         <p>
         Temos mais de uma opção, afinal, queremos que você possa saber a todo momento, onde sua carga está! 
         Nosso sistema, envia e-mails automáticos a cada movimentação da carga!
          Além disso, contamos com um Portal, que se chama, Portal do Cliente, nele, você poderá ter acesso a todos seus envios, 
          confirmações de entrega, e muito mais. Se ainda preferir, pode falar conosco através do nosso <span onClick={handleWhatsappClick}>WhatsApp</span>. 
        </p>
       </AccordionDetails>
     </FAQAccordion>

     <FAQAccordion>
       <AccordionSummary expandIcon={<img src={ArrowDown} alt=''/>}>
         <h1>O frete aéreo possui restrições?</h1>
       </AccordionSummary>
       <AccordionDetails>
         <p>
         Os envios aéreos, possuem algumas restrições sim, dentre elas, não são aceitos embarques de: mercadorias preciosas, cheques, valores em dinheiro, ou quaisquer documentos que sejam pessoais, além disso, restos mortais e armamentos também não são aptos a serem transportados.<br/><br/>
         Mercadorias que são classificadas como perigosas, devem ser analisadas, uma vez que nem todo produto perigoso, pode ser transportado, mas para isso, você poderá contar com nossa equipe, que está apta para fazer uma análise e verificar. 
         </p>
       </AccordionDetails>
     </FAQAccordion>

     <FAQAccordion>
       <AccordionSummary expandIcon={<img src={ArrowDown} alt=''/>}>
         <h1>Quais são as formas de pagamento?</h1>
       </AccordionSummary>
       <AccordionDetails>
         <p>
         Realizamos as cobranças através de boletos bancários, e para facilitar tudo para você, podemos realizar a cobrança para sua empresa, ou para seu fornecedor/cliente.
         </p>
       </AccordionDetails>
     </FAQAccordion>

     <FAQAccordion>
       <AccordionSummary expandIcon={<img src={ArrowDown} alt=''/>}>
         <h1>Posso enviar mercadorias para serem retiradas no aeroporto?</h1>
       </AccordionSummary>
       <AccordionDetails>
         <p>
         Sim, é possível, e muitos clientes optam por esse serviço! Nós lhe avisamos assim que a carga pousar, lhe instruímos, e a mercadoria poderá ser retirada no aeroporto.
         </p>
       </AccordionDetails>
     </FAQAccordion>

     <FAQAccordion>
       <AccordionSummary expandIcon={<img src={ArrowDown} alt=''/>}>
         <h1>Qual a diferença entre o transporte de mercadorias aéreo e rodoviário?</h1>
       </AccordionSummary>
       <AccordionDetails>
         <p>
         O transporte aéreo de mercadorias, além de ser a forma mais segura para transporte, apresenta maior rapidez, bem como controle mais assertivo sobre a localização da mercadoria, informações em tempo real sobre voos onde a carga se encontra e horários de pouso. Porém, em alguns casos, quando por exemplo, a mercadoria apresentar peso superior a 200 kg, ou até mesmo, a carga não for aceita para embarque aéreo (veja mais na pergunta: “O frete aéreo possui restrições?”) temos o transporte rodoviário como opção. O transporte rodoviário é bastante funcional, porém, os prazos de entrega são diferentes uma vez que os veículos utilizados para este transporte, não conseguem atingir longas distâncias em menos tempo, como ocorre no transporte aéreo.
         </p>
       </AccordionDetails>
     </FAQAccordion>

</FAQGrid >


<FormGrid container>
<Grid className='sideA' item xs={12} sm={12} md={6}>
<div className="form-text">
<h1>Não encontrou sua resposta?</h1>

<p>
Preencha o formulário abaixo e fale com nossa equipe.
</p>
</div>

<Form className='form-content' pagina={"Perguntas Frequentes"} />
</Grid>

<Grid className='sideB' item xs={12} sm={12} md={6}>
<img src={Cangoo} alt="" />
</Grid>

</FormGrid>


      <Footer/>

      </>
    )
  }